//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import { mapState } from "vuex";
import FooterData from "~/content/data/footer.json";
import LocationDropdown from "~/components/menu/LocationDropdown";

export default {
  name: "PageFooter",
  data() {
    return {
      activeSpan: 0,
      sticky: false,
      attached: true,
      footerAnchorAt: 50,
      footerAnchorOffAt: 0,
    };
  },
  components: {
    LocationDropdown,
  },
  computed: {
    ...mapState({
      page: (state) => state.pages.page,
    }),
    footer() {
      return FooterData;
    },
    yearToday() {
      return 2022;
      // return (new Date()).getYear() + 1900;
    },
    addGradient() {
      return false;
      // return (['index']).includes(this.page.slug);
    },
    footerShowAt() {
      // const isHomePage = (['index']).includes(this.page.slug);

      // if(isHomePage){
      //   if(window.innerHeight < 900) return document.querySelector('[data-section="stat-capsule"]').nextSibling.offsetTop - window.innerHeight + 100;
      //
      //  return document.querySelector('[data-section="stat-capsule"]').nextSibling.offsetTop - window.innerHeight + 100;
      // }

      return 127;
    },
    textsToRotate() {
      const value = this.footer.cta.title;
      let endString = "";
      const matches = value
        .split("[")
        .filter(function (v) {
          return v.includes("]") > -1;
        })
        .map(function (value) {
          if (value) {
            const valueSplit = value.split("]");
            endString = valueSplit[1];
            return valueSplit[0];
          }
          return "";
        });

      if (matches.length === 1) return matches[0];

      return {
        start: matches[0],
        spans: matches[1].split(","),
        end: endString,
      };
    },
    showKudosityLogo() {
      // console.log(this.$route)
      if (this.$route.name === 'legal-slug') return true
      else return false
    }
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    $(".row-menu .col-menu").on("click", function () {
      $(this).toggleClass("open");
      $(this).siblings().removeClass("open");
    });
  },
  created() {
    if (process.browser || process.client) {
      const self = this;
      this.$nextTick(function () {
        setInterval(function () {
          self.activeSpan++;
          if (self.activeSpan >= self.textsToRotate.spans.length) self.activeSpan = 0;
        }, 5000);
      });
    }
  },
  methods: {
    isRelative(url) {
      const r = new RegExp("^(?:[a-z]+:)?//", "i");
      return !r.test(url);
    },
    handleScroll() {
      const scrollY = $(window).scrollTop();
      const footerAnchor = document.querySelector(".footer-anchor");
      const footer = document.querySelector("footer");
      const footerPadTop = parseFloat(
        window.getComputedStyle(footer, null).getPropertyValue("padding-top")
      );
      const footerAnchorOffAt =
        footer.offsetTop - window.innerHeight + footerPadTop + footerAnchor.clientHeight;

      this.sticky = scrollY >= this.footerShowAt;
      this.attached = scrollY >= footerAnchorOffAt;
    },
  },
};
